import { BASE_URL } from "../config";
import { getSessionId } from "../utils/SessionHandler";
import { handleResponse } from "./responseHandler";

export async function fetchMenus() {
  const response = await fetch(`${BASE_URL}api/v1/organisation/menu`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });
  return handleResponse(response);
}
